import * as React from 'react'
import { useState } from 'react'
import { Box, Card, CardMedia, Link, Stack, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import axios from 'axios'
import Image from 'next/image'
import Router from 'next/router'
import { Input } from '#/shared'
import { getApiUrl } from '#/shared/lib/constants'
import { getDeviceType, getRandomImage } from '#/shared/lib/helpers'
import { NextPageWithLayout } from '#/pages/_app'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'

import styles from './reset.module.scss'

const Reset: NextPageWithLayout = () => {
	const device = getDeviceType()

	const [input_email, set_Email] = useState<string>('')
	const [isSend, setIsSend] = useState(false)
	const {showMessage, } = useShowDataStore()
	const sendMail = () => {
		axios.post(getApiUrl() + '/auth/update-pass', {
			email: input_email,
		})
			.then(function (response) {
				if (response.status === 200) {
					setIsSend(true)
					setTimeout(() => Router.push('/login'), 10000)
				}
			})
			.catch(function (error) {
				showMessage('Аккаунт с такой почтой не найден')
			})
	}

	const desktop = device === 'desktop'

	const refImage = React.useRef(getRandomImage())

	return (
		<Stack
			direction={desktop ? 'row' : 'column'}
			alignItems='center'
			justifyContent={desktop ? 'space-between' : 'center'}
			sx={{
				padding: 0,
				margin: desktop ? 0 : '60px auto',
				backgroundColor: '#373737',
			}}
		>
			{desktop && (
				<Card>
					<CardMedia
						sx={{ height: '100vh', width: '600px' }}
						image={`/login_images/${refImage.current}`}
					>
						<Stack
							direction='column-reverse'
							justifyContent='flex-start'
							alignItems='flex-start'
							spacing={2}
							sx={{
								wdith: '100%',
								height: '100%',
								paddingBottom: 3,
								paddingLeft: 3,
							}}
						>
							<Typography
								variant='body2'
								sx={{
									color: '#FFFFFF',
									lineHeight: '23.8px',
									fontSize: '17px',
									fontWeight: '400px',
								}}
							>
								Midjourney
							</Typography>
							<Typography
								variant='body2'
								sx={{
									color: '#FFFFFF',
									lineHeight: '28px',
									fontSize: '20px',
									fontWeight: '600px',
								}}
							>
								by honeynek
							</Typography>
						</Stack>
					</CardMedia>
				</Card>
			)}
			{!isSend ? (
				<Box
					sx={{
						width: '70%',
						height: '100%',
						marginTop: desktop ? 0 : 25,
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<Stack
						direction='column'
						justifyContent='center'
						alignItems='center'
						spacing={0}
						sx={{ width: '350px' }}
					>
						<Typography sx={{ fontSize: 25 }}>Забыли пароль?</Typography>

						<Typography marginTop={1.5} sx={{ fontSize: 16 }}>
							Введите адрес электронной почты, которую вы использовали для регистрации в сервисе
						</Typography>
						<Box textAlign='left' width='100%' marginTop={1.5}>
							<Typography marginLeft={0.5} className='title-main-gray'>
								Email
							</Typography>
						</Box>
						<Input onChange={(event) => set_Email(event.target.value)} type={'email'} fullWidth />
						<Link className={styles.closeLink} href={'/'}>
							<Image src={'/x-mark.svg'} width={18} height={18} alt={''} />
						</Link>
						<Box marginTop={2} width='100%'>
							<Button variant='contained' fullWidth className='btn-classic' onClick={sendMail}>
								Восстановить аккаунт
							</Button>
						</Box>
					</Stack>
				</Box>
			) : (
				<Box
					sx={{
						width: '40vh',
						height: '100%',
						marginRight: '25%',
					}}
				>
					<Typography
						sx={{
							fontSize: 21,
							textAlign: 'center',
							color: '#E1E1E1',
						}}
					>
						Письмо для восстановления пароля отправлено вам на почту!
					</Typography>
				</Box>
			)}
		</Stack>
	)
}

export default Reset
